module.exports = __webpack_public_path__ + "img/125.cd372fe2.png";